var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticStyle:{"margin":"0 auto"}},[_c('v-sheet',{staticClass:"pa-5",attrs:{"rounded":"md","elevation":"0"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }